/* SOLARIS — Mystery Pack (19 oct. 2026).
   1. El contador de licencias vendidas: arranca en 0 a la hora de salida y
      sube. Es una SIMULACIÓN: no lee ventas reales. Lo calcula la hora, así todos los visitantes ven la misma cifra,
      solo baja y no se reinicia al recargar. Curva: el primer día se va más de
      la mitad, luego cada vez menos; de madrugada (hora de México) casi no se
      mueve; avanza a saltos irregulares (ruido fijo por cada tramo de 10
      minutos). Al cumplirse data-horas quedan data-final sin vender (el
      margen) y ahí se queda data-espera días; después marca todas vendidas.
      El botón de compra nunca se bloquea (21 oct.: Dani). Para probar:
      ?solaris_h=30 simula la hora 30.
   2. El review de OPALYS en YouTube, sin salida a YouTube (el mismo
      reproductor de la página de compra, reducido). */
(function () {
  var raiz = document.querySelector('[data-sol]'); if (!raiz) return;

  /* ───────────── 1. Contador ───────────── */
  var inicio = Date.parse(raiz.getAttribute('data-inicio')), horas = parseFloat(raiz.getAttribute('data-horas')) || 72;
  var total = parseInt(raiz.getAttribute('data-licencias'), 10) || 100, alFinal = parseInt(raiz.getAttribute('data-final'), 10);
  if (isNaN(alFinal)) alFinal = 3;
  var espera = parseFloat(raiz.getAttribute('data-espera')); if (isNaN(espera)) espera = 7;
  var TRAMO = 10, tramos = Math.round(horas * 60 / TRAMO);
  function ruido(i) { var x = Math.sin(i * 12.9898 + 78.233) * 43758.5453; return x - Math.floor(x); }
  // Ventas acumuladas al final de cada tramo, normalizadas para que al cerrar
  // se hayan ido (total - alFinal).
  var acum = [0], suma = 0;
  for (var i = 0; i < tramos; i++) {
    var h = (i + 0.5) * TRAMO / 60;
    var horaMx = new Date(inicio + h * 3600e3 - 6 * 3600e3).getUTCHours();   // México: UTC−6
    var dia = horaMx >= 1 && horaMx < 8 ? 0.18 : (horaMx >= 19 || horaMx < 1 ? 1.35 : 1);
    var tasa = Math.exp(-h / 26) * dia * (0.25 + 1.5 * ruido(i));
    suma += tasa; acum.push(suma);
  }
  var vender = Math.max(0, total - alFinal);
  function vendidas(ms) {
    var h = (ms - inicio) / 3600e3;
    if (h <= 0) return 0;
    var k = Math.min(tramos, Math.floor(h * 60 / TRAMO));
    return Math.min(vender, Math.floor(acum[k] / suma * vender));
  }
  var forzada = /[?&]solaris_h=([\d.]+)/.exec(location.search);
  function ahora() { return forzada ? inicio + parseFloat(forzada[1]) * 3600e3 : Date.now(); }
  var cifra = raiz.querySelector('[data-sol-vendidas]'), barra = raiz.querySelector('[data-sol-barra]');
  function pintar() {
    if (isNaN(inicio)) return;
    var t = ahora(), lleno = t >= inicio + (horas + espera * 24) * 3600e3;
    var v = lleno ? total : t >= inicio + horas * 3600e3 ? vender : vendidas(t);
    cifra.textContent = v;
    barra.style.width = (v / total * 100).toFixed(1) + '%';
  }
  pintar(); if (!forzada) setInterval(pintar, 30000);

  /* ───────────── 2. Review en YouTube ───────────── */
  var el = raiz.querySelector('[data-yt]'); if (!el) return;
  var yt = null, listo = false;
  function api() {
    return new Promise(function (ok) {
      if (window.YT && window.YT.Player) { ok(window.YT); return; }
      var previo = window.onYouTubeIframeAPIReady;
      window.onYouTubeIframeAPIReady = function () { if (previo) previo(); ok(window.YT); };
      var sc = document.createElement('script'); sc.src = 'https://www.youtube.com/iframe_api'; sc.async = true; document.head.appendChild(sc);
    });
  }
  function arrancar() {
    if (yt) { if (listo) { if (el.classList.contains('is-sonando')) yt.pauseVideo(); else yt.playVideo(); } return; }
    api().then(function (YT) {
      var div = document.createElement('div'); el.querySelector('[data-yt-lienzo]').appendChild(div);
      yt = new YT.Player(div, {
        videoId: el.getAttribute('data-yt'), host: 'https://www.youtube-nocookie.com',
        playerVars: { start: parseInt(el.getAttribute('data-yt-inicio'), 10) || 0, autoplay: 1, controls: 0, disablekb: 1, fs: 0, rel: 0, iv_load_policy: 3, modestbranding: 1, playsinline: 1 },
        events: {
          onReady: function () { listo = true; el.classList.add('is-listo'); yt.playVideo();
            setTimeout(function () { if (yt.getPlayerState() !== YT.PlayerState.PLAYING) { yt.mute(); yt.playVideo(); } }, 1500); },
          onStateChange: function (e) {
            el.classList.toggle('is-sonando', e.data === YT.PlayerState.PLAYING);
            if (e.data === YT.PlayerState.PLAYING) { try { yt.unloadModule('captions'); } catch (err) {} }
          }
        }
      });
    });
  }
  el.querySelector('[data-yt-play]').addEventListener('click', arrancar);
  el.querySelector('[data-yt-escudo]').addEventListener('click', arrancar);
})();
